import { loadMissingFeatures } from '../polyfills';
import type { IntlCheck } from '../types';

export async function loadPolyfill(locale: string, deps: readonly IntlCheck[]): Promise<void> {
	await loadMissingFeatures(deps, locale);
	await import(/* webpackChunkName: "polyfill/intl-locale/polyfill" */ '@formatjs/intl-locale/polyfill');
}
